/**
 * Утилиты для работы с Janus WebRTC
 */

import type { JanusIceServer } from "@/src/lib/janus/JanusHelper";

/**
 * Нормализует URL Janus сервера
 */
export function normalizeJanusServerUrl(raw: unknown): string | null {
  const host = typeof raw === "string" ? raw.trim() : "";
  if (!host) return null;

  const hasProtocol = /^https?:\/\//i.test(host) || /^wss?:\/\//i.test(host);
  return hasProtocol ? host : `wss://${host}`;
}

/**
 * Нормализует ICE серверы для Janus
 */
export function normalizeIceServers(raw: unknown): JanusIceServer[] {
  if (!Array.isArray(raw)) return [];

  return raw
    .map((s): JanusIceServer | null => {
      if (!s || typeof s !== "object") return null;

      const record = s as Record<string, unknown>;
      const urlsRaw = record.urls ?? record.url;

      const isUrlsString = typeof urlsRaw === "string";
      const isUrlsArrayOfString =
        Array.isArray(urlsRaw) && urlsRaw.every((u) => typeof u === "string");

      if (!isUrlsString && !isUrlsArrayOfString) return null;

      const username = typeof record.username === "string" ? record.username : undefined;
      const credential = typeof record.credential === "string" ? record.credential : undefined;

      return {
        urls: urlsRaw as string | string[],
        username,
        credential,
      };
    })
    .filter((v): v is JanusIceServer => v != null);
}

/**
 * Нормализует room ID для Janus
 */
export function normalizeJanusRoom(raw: unknown): number | string | null {
  if (typeof raw === "number" && Number.isFinite(raw)) return raw;
  if (typeof raw === "string") {
    const trimmed = raw.trim();
    if (trimmed) return trimmed;
  }
  return null;
}